<template>
  <div class="page-container">
    <div v-if="loading" class="page-loading">
      <van-loading type="spinner" size="36" vertical>加载中...</van-loading>
    </div>
    <div class="custom-header">
      <div class="header-left">
        <img :src="imgSrc" class="header-logo" />
        <div class="header-title">智能 · 高效</div>
      </div>
      <div style="justify-content: end;display:flex; " @click="exitPage">
        <van-icon class="iconfont icon-chuqudengji" size="20" color="#fff" />
      </div>
    </div>
    <!-- <div class="page-content"> -->
    <div style="height:81vh;overflow-y:auto;margin-top:55px ">
      <div
          v-for="(item,index) in menuArr"
          :key="index"
          class="module-section">
        <div class="module-card">

          <div class="module-title">
            {{ item.MODNM }}
          </div>

          <div class="card-grid">

            <div
                class="card-item"
                v-for="(it,ind) in formArr.filter(it=>it.MODIDSEQ==item.IDSEQ)"
                :key="ind"
                @click="itemClick(it.FRMURL)"
            >

              <span v-if="pendingCounts[menuPath(it.FRMURL)] && (pendingCounts[menuPath(it.FRMURL)].error || pendingCounts[menuPath(it.FRMURL)].count > 0)" class="pending-badge" role="status" :title="pendingCounts[menuPath(it.FRMURL)].error ? '数量获取失败，返回首页后重试' : '待处理单据数量'">{{ pendingCounts[menuPath(it.FRMURL)].error ? '!' : pendingCounts[menuPath(it.FRMURL)].count > 99 ? '99+' : pendingCounts[menuPath(it.FRMURL)].count }}<span v-if="pendingCounts[menuPath(it.FRMURL)].error" class="badge-error-text">数量获取失败</span></span>
              <div
                  class="card-icon"
                  :style="{ background: getGradientColor(ind) }"
              >
                <van-icon
                    size="26"
                    :class="it.FICON"
                    color="#fff"
                />
              </div>

              <div
                  class="card-title"
                  :class="it.ISLOCK=='N'?'':'card-disabled'"
              >
                {{ it.TITLE }}
              </div>

            </div>

          </div>
        </div>
      </div>

    </div>

    <!-- 返回顶部 -->
    <div
        class="go_top_btn"
        v-show="topShow"
        @click="goTop"
    >
      <van-icon name="arrow-up" size="22" color="#235EFF"/>
    </div>

  </div>
</template>

<script>
import { pendingDocuments, menuPath, pendingCountRequest, parsePendingCount } from '@/api/pendingDocuments'

export default {
  name: "Features",

  data() {
    return {
      pendingCounts: {},
      countSequence: 0,
      menuIdentity: '',
      loading: false,
      topShow:false,
      scroll:0,
      v_username:this.$cookies.get('v_telno'),
      menuArr:[],
      formArr:[],
      imgSrc: require("@/assets/title.png")
    };
  },

  mounted(){
    if(this.v_username){
      this.getMenuList()
      window.addEventListener("scroll",this.windowScroll)
      document.addEventListener("visibilitychange", this.onPageVisible)
    }else{
      this.$router.push({path:'/login'})
    }
  },

  activated(){
    this.startPendingTimer()
    if (this.menuIdentity) this.refreshPendingCounts()
    else if (!this.loading) this.getMenuList()
  },
  deactivated(){
    this.stopPendingTimer()
  },
  beforeDestroy(){
    this.stopPendingTimer()
    this.countSequence++
    window.removeEventListener('scroll', this.windowScroll)
    document.removeEventListener('visibilitychange', this.onPageVisible)
  },
  methods:{
    menuPath,
    startPendingTimer(){
      this.stopPendingTimer()
      this._pendingTimer = setInterval(() => {
        if (this.$route.path === '/features' && document.visibilityState === 'visible' && this.menuIdentity) {
          this.refreshPendingCounts()
        }
      }, 60 * 60 * 1000)
    },
    stopPendingTimer(){
      if (this._pendingTimer) clearInterval(this._pendingTimer)
      this._pendingTimer = null
    },
    onPageVisible(){
      if (document.visibilityState === 'visible' && this.$route.path === '/features') this.refreshPendingCounts()
    },
    identity(){ return [this.$cookies.get('v_telno'), this.$cookies.get('v_corpid')].join(':') },
    async refreshPendingCounts(){
      const identity = this.identity()
      if (identity !== this.menuIdentity) {
        this.countSequence++
        this.pendingCounts = {}
        this.menuArr = []
        this.formArr = []
        this.menuIdentity = ''
        this.v_username = this.$cookies.get('v_telno')
        if (this.v_username && this.$cookies.get('v_corpid')) this.getMenuList()
        else this.$router.push('/login')
        return
      }
      const sequence = ++this.countSequence
      const corpid = this.$cookies.get('v_corpid')
      const paths = [...new Set(this.formArr.filter(item => item.ISLOCK === 'N' && this.menuArr.some(menu => menu.IDSEQ == item.MODIDSEQ) && this.$router.resolve(item.FRMURL).resolved.matched.length).map(item => menuPath(item.FRMURL)))].filter(path => pendingDocuments[path])
      await Promise.all(paths.map(async path => {
        try {
          const response = await this.axios({ method: 'post', url: 'xuper_auth/getRecordCnt', data: pendingCountRequest(path, corpid) })
          const count = parsePendingCount(response)
          if (sequence === this.countSequence && identity === this.identity()) this.$set(this.pendingCounts, path, { count, error: false })
        } catch (error) {
          if (sequence === this.countSequence && identity === this.identity()) this.$set(this.pendingCounts, path, { error: true })
        }
      }))
    },
    // 退出系统
    exitPage() {
      this.$dialog.confirm({
        title: '提示',
        message: '你确定要退出系统吗?',
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      }).then(() => {
        this.countSequence++
        this.pendingCounts = {}
        this.menuIdentity = ''
        this.formArr = []
        this.menuArr = []
        this.$store.dispatch('logout')
        this.$router.push({ path: '/login' })
      }).catch(() => {})
    },
    getGradientColor(index){
      const gradients=[
        'linear-gradient(135deg,#5F86F1,#235EFF)',
        'linear-gradient(135deg,#00EFC5,#01B990)',
        'linear-gradient(135deg,#F9B26B,#FA5A21)',
        'linear-gradient(135deg,#F8E040,#FBA703)',
        'linear-gradient(135deg,#8FCFEA,#427BEC)',
        'linear-gradient(135deg,#A78BFA,#7C3AED)'

      ]
      return gradients[index%gradients.length]
    },

    itemClick(url){
      let resolvedRoute=this.$router.resolve(url).resolved
      if(resolvedRoute.matched&&resolvedRoute.matched.length>0){
        this.$router.push({
          path:url,
          query:{path:url, ...(pendingDocuments[menuPath(url)] ? { pending: '1' } : {})}
        })
      }else{
        this.$dialog.alert({
          title:'提示',
          message:'正在开发中...'+url
        })
      }

    },

    getMenuList(){
      const identity = this.identity()
      this.v_username = this.$cookies.get('v_telno')
      if (!this.v_username || !this.$cookies.get('v_corpid')) { this.$router.push('/login'); return }
      this.loading = true
      let v_cond=" and idseq in (select modidseq from v_sys_user_priv where issel='Y' and userno='"+this.v_username+"') "
      let v_cond2=" and frmidseq in (select frmidseq from v_sys_user_priv where issel='Y' and userno='"+this.v_username+"') "
      const menuRequest = this.axios({
        method:'post',
        url:'xuper_auth/getBaseData',
        data:{
          p_table:'V_SYS_MOD',
          p_cond:v_cond+" and isfront='Y' order by sortby"
        }
      }).then(res=>{
        if(res.code==='200' && identity === this.identity()){
          this.menuArr=res.result
        }
      })
      const formRequest = this.axios({
        method:'post',
        url:'xuper_auth/getBaseData',
        data:{
          p_table:'V_SYS_MOD_FORM',
          p_cond:v_cond2+" and isfront='Y' order by sortby"
        }

      }).then(res=>{
        if(res.code==='200' && identity === this.identity()){
          this.formArr=res.result
        }
      })
      Promise.allSettled([menuRequest, formRequest]).then(() => {
        this.loading = false
        if (identity === this.identity()) { this.menuIdentity = identity; this.refreshPendingCounts() }
      })
    },
    windowScroll(){
      this.scroll=document.documentElement.scrollTop||document.body.scrollTop
      this.topShow=this.scroll>300
    },

    goTop(){
      let timer=setInterval(()=>{
        let osTop=document.documentElement.scrollTop||document.body.scrollTop
        let speed=Math.floor(-osTop/5)
        document.documentElement.scrollTop=document.body.scrollTop=osTop+speed
        if(osTop===0){
          clearInterval(timer)
        }
      },30)
    }
  }
}
</script>

<style scoped lang="scss">
.card-item { position: relative; }
.pending-badge { position: absolute; top: 6px; right: 6px; min-width: 20px; height: 20px; padding: 0 5px; box-sizing: border-box; border-radius: 12px; background: #ff6168; color: white; font-size: 12px; line-height: 20px; text-align: center; z-index: 1; }
.badge-error-text { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); }


.page-loading{
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,.82);
}
 
.page-container{
  width:100%;
  height:100%;
  background:#F7F8FA;
}

.custom-header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 16px;
  background: #235eff;
  color: #fff;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(35, 94, 255, 0.15);
}

.header-left{
  display:flex;
  align-items:center;
}

.header-logo{
  width: 120px;
  height: 40px;
  margin-right: 12px;
  object-fit: contain;
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 1px;
}


.page-content{
  margin-top:56px;
  padding:16px;
  padding-bottom:70px;
}

.module-section{
  margin-bottom:16px;
}

.module-card{
  background:#fff;
  border-radius:8px;
  padding:14px;
  border:1px solid #f0f0f0;
}

.module-title{
  font-size:15px;
  font-weight:600;
  margin-bottom:14px;
  padding-left:10px;
  border-left:3px solid #235EFF;
}

/* grid */

.card-grid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:10px;
}

.card-item{
  height:88px;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;

  border-radius:8px;

  background:#fff;
  border:1px solid #f3f3f3;

  transition:transform .15s;

}

.card-item:active{
  transform:scale(.96);
  background:#f7f8fa;
}

.card-icon{

  width:40px;
  height:40px;

  border-radius:50%;

  display:flex;
  align-items:center;
  justify-content:center;

  margin-bottom:6px;

}

.card-title{
  font-size:12px;
  color:#333;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  font-weight:600;
  max-width:90%;
}

.card-disabled{
  color:#999;
}

.go_top_btn{
  position:fixed;
  right:16px;
  bottom:90px;
  width:44px;
  height:44px;
  border-radius:50%;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  border:1px solid #eee;
  box-shadow:0 2px 6px rgba(0,0,0,0.08);
  z-index:80;
}

</style>
